// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import LinearProgress from '@mui/material/LinearProgress'

// ** Icon Imports
import Icon from '../icon';
import { Divider } from '@mui/material'

interface Props {
    title?: string
    amount?: string
    percentage?: string
    value1?: any
    value2?: any
    value3?: any
    color?: any
}

const CardStats = (props: Props) => {
    function number(x: any) {
        return x.replaceAll('.', '')
    }

    function percentage(x: any, y: any) {
        return Math.floor((number(x) / number(y)) * 100)
    }

    return (
        <div className={'content-block dx-card'}>
            <CardHeader title={props.title} sx={{ textAlign: 'center' }} />
            <Divider />
            <CardContent sx={{ pt: theme => `${theme.spacing(2.5)} !important` }}>
                <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant='h5' sx={{ mr: 0.5, fontWeight: 600 }}>
                        {percentage(props.value2, props.value1)}%
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', color: 'success.main', '& svg': { mr: 0.5 } }}>
                        <Typography variant='h5' sx={{ mr: 0.5, fontWeight: 600 }}>
                            {percentage(props.value3, props.value1)}%
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography sx={{ mr: 2, fontWeight: 600 }}>PR</Typography>
                        <Typography variant='body2' sx={{ fontWeight: 'bold', color: '#212121' }}>
                            {props.value1}
                        </Typography>
                    </Box>
                    <LinearProgress
                        color={'primary'}
                        sx={{ color: '#212121' }}
                        value={(parseFloat(props.value1) / parseFloat(props.value1)) * 100}
                        variant='determinate'
                    />
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography sx={{ mr: 2, fontWeight: 600 }}>PO</Typography>
                        <Typography variant='body2' sx={{ fontWeight: 'bold', color: '#212121' }}>
                            {props.value2}
                        </Typography>
                    </Box>
                    <LinearProgress color={'info'} value={percentage(props.value2, props.value1)} variant='determinate' />
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography sx={{ mr: 2, fontWeight: 600 }}>GR</Typography>
                        <Typography variant='body2' sx={{ fontWeight: 'bold', color: '#212121' }}>
                            {props.value3}
                        </Typography>
                    </Box>
                    <LinearProgress color={'warning'} value={percentage(props.value3, props.value1)} variant='determinate' />
                </Box>
            </CardContent>
        </div>
    )
}

export default CardStats
